import React, { useEffect, useRef, useState } from 'react';
import { ModalProvider } from 'styled-react-modal';
import styled, { ThemeProvider } from 'styled-components';
import { CookiesProvider } from 'react-cookie';
import {
  useLocation, useNavigate,
  Routes,
  Route,
  Navigate,
  Location
} from 'react-router-dom';
import moment from 'moment'
import { useLazyQuery } from '@apollo/client';
import { ToastContainer } from 'react-toastify';
import { GET_FEATURE_TOGGLES_LIST } from './graphql/queries';
import { ToggleValues } from './utils/featureToggle/toggle';
import { TOUCH } from './graphql/mutations';
import theme from './styles/theme';
import ErrorBoundary from './components/ErrorBoundary';
// @ts-ignore
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import SignedIn, { MustCompleteRoute, StandardRoute } from './pages/SignedIn';
import { CleanDom } from './utils/domCleanup';
import { GlobalStyle } from './styles/globalStyle';
import Dashboard from './pages/Dashboard';
import CompleteProfile from './pages/CompleteProfile';
import Patient from './pages/Patient';
import SessionTimeout from './components/SessionTimeout';
import Patients from './pages/Patients';
import { Messages } from './pages/Messages';
import { Profile } from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AccountLocked from './pages/AccountLocked';
import UnlockAccount from './pages/UnlockAccount';
import Impersonate from './pages/Impersonate';
import Resources from './pages/Resources';
import Settings from './pages/Settings';
import Visit from './pages/Visit';
import PatientCase from './pages/patient/PatientCase';
import { ToastProvider } from 'react-toast-notifications';
import FormBuilder from './pages/FormBuilder';
import FormListing from './pages/FormListing';
import { NewNote } from './pages/NewNote';
import { Inxs } from './pages/Inxs';
import { PreCheckin } from './pages/PreCheckin';

const SpecialModalBackground = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 68.8125em) {
  z-index: 10000;
  }
`

const App = () => {
  const lastLocationRef = useRef<string | null>(null)

  const location = useLocation()
  const navigate = useNavigate()

  const [isFeatureToggleLoaded, setIsFeatureToggleLoaded] = useState(false)
  const [getFeatureToggles, { client }] = useLazyQuery(GET_FEATURE_TOGGLES_LIST)

  useEffect(() => {
    const loadFeatureToggles = async () => {
      try {
        const res = await getFeatureToggles();

        if (res?.data?.getFeatureTogglesList) {
          ToggleValues.list = res.data.getFeatureTogglesList;
        }

        setIsFeatureToggleLoaded(true);
      } catch (err) {
        // optional: handle/log error
        console.error(err);
      }
    };

    loadFeatureToggles();


    // loadFeatureToggles()

    // return () => {
    // }
  }, [getFeatureToggles])

  useEffect(() => {
    if (location && location.pathname !== lastLocationRef.current) {
      if (location.pathname === '/logout' || location.pathname === '/login') {
        lastLocationRef.current = location.pathname
        sessionStorage.setItem('lastPath', location.pathname)
      } else {
        heartbeat()
      }
      var images = document.getElementsByTagName('img');
      for (let index = 0; index < images.length; index++) {
        const element = images[index];

        if (element.currentSrc && element.currentSrc.indexOf('https://s.amazon-adsystem') > -1) {
          element.style.position = 'absolute'
          element.style.top = '0'
        }
      }
    } else if (!location) {
      sessionStorage.removeItem('lastPath')
    }
  }, [location.pathname])

  const heartbeat = async () => {
    if (location.pathname === '/logout' ||
      location.pathname === '/login' ||
      (location.pathname || '').indexOf('/reset-password') > -1 ||
      location.pathname === '/forgot-password' ||
      (location.pathname || '').indexOf('/unlock/') > -1 ||
      location.pathname === '/account-locked') {
      return
    }
    let timeStamp = moment().format();
    sessionStorage.setItem('LH', timeStamp);
    const lastPath = sessionStorage.getItem('lastPath')
    if (location && location.pathname && location.pathname !== lastPath) {
      const { data } = await client.mutate({
        mutation: TOUCH,
      });

      if (!data || !data.touchHealthCoach || !data.touchHealthCoach.token) {
        localStorage.removeItem('token');
        (window as any).location = '/logout';
        return;
      }
      sessionStorage.setItem('lastPath', location.pathname)
      localStorage.setItem('token', data.touchHealthCoach.token);
    }
  }

  const touch = async () => {
    const { data } = await client.mutate({
      mutation: TOUCH,
    });

    if (!data || !data.touchHealthCoach || !data.touchHealthCoach.token) {
      localStorage.removeItem('token');
      (window as any).location = '/logout';
      return;
    }
    localStorage.setItem('token', data.touchHealthCoach.token);
  }

  const timeoutLogout = () => {
    console.log('timeoutLogout!!!')
    if (location && location.pathname) {
      if (location.pathname !== '/login' &&
        location.pathname !== '/logout' &&
        (location.pathname || '').indexOf('/reset-password') < 0 &&
        location.pathname !== '/forgot-password' &&
        (location.pathname || '').indexOf('/unlock/') < 0 &&
        location.pathname !== '/account-locked')
        localStorage.setItem('route', location.pathname);
    } else {
    }
    localStorage.removeItem('token');
    navigate('/logout');
  };

  if (!isFeatureToggleLoaded) return <div />;

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <ErrorBoundary>
          <ModalProvider backgroundComponent={SpecialModalBackground}>
            <CookiesProvider>
              <>
                <Routes>
                  <Route path="/login" element={<PublicRoute component={Login} />} />
                  <Route path="/forgot-password" element={<PublicRoute component={ForgotPassword} />} />
                  <Route path="/reset-password/:id" element={<PublicRoute component={ResetPassword} />} />
                  <Route path="/account-locked" element={<PublicRoute component={AccountLocked} />} />
                  <Route path="/unlock/:uid" element={<PublicRoute component={UnlockAccount} />} />
                  <Route path="/impersonate" element={<ProtectedRoute location={location} component={Impersonate} />} />
                  <Route path="/visit" element={<ProtectedRoute location={location} component={Visit} />} />
                  <Route
                    path="/" element={
                      <ProtectedRoute
                        location={location}
                        component={SignedIn}
                      />} >
                    <Route index element={<StandardRoute component={Dashboard} />} />
                    <Route path="/messages/*" element={<StandardRoute component={Messages} />} />
                    <Route path="/patients" element={<StandardRoute component={Patients} />} />
                    <Route path="/patient/:id" element={<StandardRoute component={Patient} />} >
                      <Route path="patientCase/:caseId" element={<PatientCase />} />
                    </Route>
                    <Route path="/profile" element={<StandardRoute component={Profile} />} />
                    <Route path="/resources" element={<StandardRoute component={Resources} />} />
                    <Route path="/settings" element={<StandardRoute component={Settings} />} />
                    <Route path="/form-builder" element={<StandardRoute component={FormBuilder} />} />
                    <Route path="/form-listing" element={<StandardRoute component={FormListing} />} />
                    <Route path="/new-note/:id/:frmId" element={<StandardRoute component={NewNote} />} />
                    <Route path="/inxs/*" element={<StandardRoute component={Inxs} />} />
                    <Route path="/pre-checkin" element={<StandardRoute component={PreCheckin} />} />
                    <Route
                      path="/complete-profile" element={
                        <MustCompleteRoute
                          component={CompleteProfile}
                        />} />
                  </Route>

                  <Route
                    path="/logout"
                    element={<Logout client={client} />}
                  />
                </Routes>
                {location.pathname !== '/login' &&
                  location.pathname !== '/logout' &&
                  (location.pathname || '').indexOf('/reset-password') < 0 &&
                  location.pathname !== '/forgot-password' &&
                  (location.pathname || '').indexOf('/unlock/') < 0 &&
                  location.pathname !== '/account-locked' && (
                    <SessionTimeout heartbeat={touch} lastLocationRef={lastLocationRef.current} client={client} logout={() => {
                      timeoutLogout()
                    }} />
                  )}

                {/* <VisitPopable /> */}
                <GlobalStyle />
                <ToastContainer />
              </>
            </CookiesProvider>
          </ModalProvider>
        </ErrorBoundary>
      </ToastProvider>
    </ThemeProvider>
  );
}


const PublicRoute = ({ component: Component, ...rest }: { component: React.FC<any> }) => {
  CleanDom()
  const token = localStorage.getItem('token');
  if (!token) {
    document.body.style.backgroundColor = 'white';
    return <Component {...rest} />;
  } else {
    document.body.style.backgroundColor = '#FDF5F2';
    return <Navigate to={{ pathname: '/' }} />;
  }
};

const ProtectedRoute = ({ component: Component, location, ...rest }: { location: Location, component: React.FC<any> }) => {
  const token = localStorage.getItem('token');
  CleanDom()

  localStorage.setItem('route', location.pathname);
  if (token) {
    document.body.style.backgroundColor = '#e9f2ff';
    return <Component {...rest} />;
  } else {
    document.body.style.backgroundColor = 'white';
    return <Navigate to={{ pathname: '/logout' }} />;
  }
};

const Logout: React.FC<any> = ({ client }) => {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    async function logout() {
      let route = localStorage.getItem('route')?.toString();
      if (route === '/impersonate') {
        route = '/'
      }
      localStorage.clear()
      client.cache.data.clear();
      client.clearStore();
      localStorage.setItem('route', route || '');
      setLoaded(true)
    }
    logout()
  }, [])

  if (!loaded) return null

  return <Navigate to={'/login'} />;

}

export default App;